import React from "react";

/**
 * Modal shown when the company has no Google Ads accounts connected.
 * Offers "Connect Google Ads" (OAuth popup) and "Skip for now".
 */
const ConnectGoogleAdsModal = ({ isOpen, onClose }) => {
  const rootElement = document.getElementById("react-root");
  const hasGoogleAdsAccounts = rootElement?.getAttribute("has-google-ads-accounts") === "true";

  const openGoogleAdsPopup = () => {
    const url = "/google_ads/oauth/authorize?popup=1";
    const width = 600;
    const height = 700;
    const popupLeft = (window.innerWidth - width) / 2;
    const popupTop = (window.innerHeight - height) / 2;

    const popup = window.open(
      url,
      `googleAdsAuth_${Date.now()}`,
      `popup=yes,width=${width},height=${height},top=${popupTop},left=${popupLeft},resizable=yes,scrollbars=yes,toolbar=0,location=0,menubar=0,status=0`
    );

    if (!popup) {
      alert("Please allow popups in your browser. Redirecting...");
      window.location.href = url;
    }
  };

  if (!isOpen || hasGoogleAdsAccounts) {
    return null;
  }

  return (
    <div
      className="modal-overlay connect-page-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="modal-container connect-page-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="connect-page-header">
          <h2>Connect Google Ads Account</h2>
        </div>

        <div className="connect-page-content">
          <div className="google-ads-account-types-info" style={{ marginBottom: 16, padding: "12px 14px", background: "#f0f4f8", borderRadius: 8, fontSize: 13, color: "#374151" }}>
            <strong>Account types:</strong> A <strong>Manager account</strong> (MCC) lets you manage multiple Google Ads accounts in one place. A <strong>Standard account</strong> is where you create and run campaigns. When you connect, we list both; choose a standard account for creating campaigns.
          </div>
          <div className="platform-tiles">
            <div
              className="platform-tile connect-page-tile-clickable"
              onClick={openGoogleAdsPopup}
              style={{
                background: "#fff",
                border: "2px solid #e5e7eb",
                padding: "24px",
                borderRadius: "12px",
                cursor: "pointer",
                textAlign: "center",
              }}
            >
              <div className="platform-icon" style={{ marginBottom: "12px" }}>
                <svg width="48" height="48" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                </svg>
              </div>
              <h3 style={{ margin: "0 0 8px", fontSize: "18px", color: "#111827" }}>Connect Google Ads Account</h3>
              <p style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}>
                Connect your Google Ads account to create and manage Search campaigns
              </p>
            </div>
          </div>

          <div className="connect-page-skip-wrap">
            <button type="button" onClick={onClose} className="connect-page-skip-btn">
              Skip for now (AI Draft only)
            </button>
            <p className="connect-page-skip-note">
              You can still generate AI campaigns without connecting Google Ads
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectGoogleAdsModal;
